import React from "react"

const Institucional =()=>{
    return(
        <h1>Institucional</h1>
    )
}
export default Institucional 